// removed by extract-text-webpack-plugin
module.exports = {"fileInputWrapper":"MedicineInfoAdder__fileInputWrapper___1PttY","hasUpdated":"MedicineInfoAdder__hasUpdated___2U0NL","fileLabel":"MedicineInfoAdder__fileLabel___1mPaP","fileInput":"MedicineInfoAdder__fileInput___2ertv","fileName":"MedicineInfoAdder__fileName___1Gxg1","button":"MedicineInfoAdder__button___2dAxq"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/MedicineInfoAdder.css
// module id = 396
// module chunks = 0